/**
 * @internal
 */
/**
 * These are used to docgen the ArgTypes in stories.tsx
 */
const docgenInterface = () => 
/* eslint-disable-next-line react/display-name, @typescript-eslint/no-unused-vars */
(props) => null;
export default docgenInterface;
export const docgenFromInterface = (name, ntrfc) => {
    name;
    ntrfc;
    return {};
};
export const docgenEnum = (name, enumItem) => {
    const enumValues = [];
    const internalCSSCustomPropertiesPrefix = '--cw-internal';
    for (const item of Object.keys(enumItem)) {
        const value = enumItem === null || enumItem === void 0 ? void 0 : enumItem[item];
        if (item.charAt(0) !== '-' &&
            item.charAt(1) !== '-' &&
            value.indexOf(internalCSSCustomPropertiesPrefix) === -1) {
            enumValues.push(`  ${item} = "${value}",`);
        }
    }
    return `
\`\`\`ts
enum ${name} {
${enumValues.join('\n')}
}
\`\`\``;
};
export const enumValues = (name, enumItem) => {
    const enumValues = [];
    for (const item of Object.keys(enumItem)) {
        enumValues.push(item);
    }
    return enumValues;
};
